import { APP_URL } from 'utils/system/envs-constants';
export const localIconUrl = (size) => `/assets/front/NIT_${size}x${size}.png`;
export const iconUrl = (size) => `${APP_URL}${localIconUrl(size)}`;
